import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  IonItem,
  IonLabel,
  IonList,
  IonSearchbar,
  IonSpinner,
} from "@ionic/react";
import { Address } from "@/modules/shared/shared.types";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { AppGoogleMapsCtx } from "@/modules/shared/ctxs/AppGoogleMapsCtx";

const mockAddressData: Address[] = [
  {
    name: "Home",
    coords: { lang: 1, lat: 2 },
  },
  {
    name: "Workplace",
    coords: { lang: 3, lat: 4 },
  },
  {
    name: "School",
    coords: { lang: 5, lat: 6 },
  },
  {
    name: "Park",
    coords: { lang: 7, lat: 8 },
  },
  {
    name: "Restaurant",
    coords: { lang: 9, lat: 10 },
  },
];

const searchOptions = {
  // types: ["address"],
  types: [],
  // componentRestrictions: { country: "il" },
};

type Props = {
  model: AddressModel;
  onChange: (outs: AddressModel) => void;
};

export type AddressSearchProps = Props;

export function AddressSearch(props: Props) {
  const { loaded: MapScriptLoaded } = useContext(AppGoogleMapsCtx);

  const [address, setAddress] = useState(props.model);

  useEffect(() => {
    setAddress(props.model);
  }, [props.model]);

  const onSelect = useCallback(async (addressText: string) => {
    const results = await geocodeByAddress(addressText);
    const ll = await getLatLng(results[0]);

    setAddress({ text: addressText, location: { lat: ll.lat, long: ll.lng } });

    const model: AddressModel = {
      text: addressText,
      location: { lat: ll.lat, long: ll.lng },
    };

    localStorage.setItem(ADDRESS_SERACH_STG_KEY, JSON.stringify(model));

    props.onChange(model);
  }, []);

  const onChange = useCallback((addressText: string) => {
    setAddress(() => ({ ...address, text: addressText }));

    if (!address.text.trim()) {
      localStorage.removeItem(ADDRESS_SERACH_STG_KEY);
    }
  }, []);

  return (
    <>
      {MapScriptLoaded && (
        <PlacesAutocomplete
          value={address.text}
          onChange={onChange}
          onSelect={onSelect}
          searchOptions={searchOptions}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => {
            const iptProps = getInputProps();
            // onChange and maybe others props are NOT compatiable with IonInput event declaration type
            // so extract and leave what compataible + map props as needed like onIonInput.
            const { onChange, ...restIptPropes } = iptProps;

            return (
              <div>
                <IonSearchbar
                  {...restIptPropes}
                  placeholder="כתובת"
                  debounce={1250}
                  style={{
                    "--border-radius": "var(--app-radius-sm)",
                    "--box-shadow": "var(--app-shadow-card)",
                    "--min-height": "64px",
                    fontSize: "1.2rem",
                    padding: 0,
                  }}
                  onIonInput={(evt) => {
                    iptProps.onChange({
                      target: { value: evt.detail.value || "" },
                    });
                  }}
                />

                {(loading || suggestions.length > 0) && (
                  <IonList
                    lines="full"
                    className="ion-no-padding"
                    style={{
                      borderRadius: "var(--app-radius-sm)",
                      boxShadow: "var(--app-shadow-card)",
                      marginTop: 4,
                      overflow: "hidden",
                      background: "var(--ion-card-background)",
                    }}
                  >
                    {loading && (
                      <IonItem
                        key={0}
                        style={{ "--background": "var(--ion-card-background)" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyItems: "center",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <IonSpinner />
                        </div>
                      </IonItem>
                    )}

                    {suggestions.map((suggestion) => {
                      return (
                        <IonItem
                          {...getSuggestionItemProps(suggestion)}
                          key={suggestion.placeId}
                          style={{
                            "--background": "var(--ion-card-background)",
                          }}
                        >
                          <IonLabel>{suggestion.description}</IonLabel>
                        </IonItem>
                      );
                    })}
                  </IonList>
                )}
              </div>
            );
          }}
        </PlacesAutocomplete>
      )}
    </>
  );
}

export const ADDRESS_SERACH_STG_KEY = "AddressModel";

export type AddressModel = {
  text: string;
  location: { lat: number; long: number };
};

export const EMPTY_ADDRESS = {
  text: "",
  location: { lat: 0, long: 0 },
};
